import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

enum RoomEvent {
    /**
     * User joins a room (presence) as a guest
     */
    JOIN_ROOM = "join_room",
    /**
     * User joins room video call
     */
    JOIN_ROOM_CALL = "join_room_call",
    /**
     * User enters the Public Room lobby.
     */
    ENTER_LOBBY = "enter_lobby",
    /**
     * User enters the AI lobby
     */
    ENTER_AI_LOBBY = "enter_ai_lobby",
    /**
     * User clicks to view a room
     */
    VIEW_ROOM = "view_room",
}

interface RoomEventDetails {
    readonly roomId: string;
    readonly performedAsHost: boolean;
}

interface RoomPresenceEventDetails extends RoomEventDetails {
    readonly numRoomParticipants: number;
}

interface RoomCallEventDetails extends RoomEventDetails {
    readonly numRoomCallParticipants: number;
}

interface ViewRoomDetails {
    readonly roomId: string;
    readonly isPersonalRoom: boolean;
    readonly source: "home_menu";
}

export class JoinRoomEvent extends AmplitudeEvent {
    constructor(eventDetails: RoomPresenceEventDetails) {
        super(RoomEvent.JOIN_ROOM);
        this.props = { ...eventDetails };
    }
}

export class JoinRoomCallEvent extends AmplitudeEvent {
    constructor(eventDetails: RoomCallEventDetails) {
        super(RoomEvent.JOIN_ROOM_CALL);
        this.props = { ...eventDetails };
    }
}

export class EnterAiLobby extends AmplitudeEvent {
    constructor(source: "home_menu") {
        super(RoomEvent.ENTER_AI_LOBBY);
        this.props = { source: source };
    }
}

export class ViewRoom extends AmplitudeEvent {
    constructor(eventDetails: ViewRoomDetails) {
        super(RoomEvent.VIEW_ROOM);
        this.props = { ...eventDetails };
    }
}
